import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	EditEmployeeTransactionsContainer,
	EditItemsContainer,
} from "./style";
import { EmployeeItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useNewsContext } from "../../context/EventsContext/NewsContext";

const EditEvents = () => {
	const { updateNews, loadingEditNewsData } = useNewsContext();
	return (
		<EditEmployeeTransactionsContainer>
			<EditItemsContainer>
				<h3>Etkinlik Güncelle</h3>
				<Divider />
				<Collapse
					items={EmployeeItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={({ isActive }) => (
						<UpOutlined rotate={isActive ? 0 : -180} />
					)}
					defaultActiveKey={["1", "2", "3", "4", "5", "6"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={updateNews} type="default" loading={loadingEditNewsData}>
						Güncelle
					</MainButtonComponent>
				</ActionButtonComponent>
			</EditItemsContainer>
		</EditEmployeeTransactionsContainer>
	);
};

export default EditEvents;
